<template>
  <nav class="nav-menu" :class="{ condensed: condensed }">
    <span class="nav-menu-left">
      <a id="logo">
        <img src="./../../assets/images/logo-white.png" alt="Autism Diagnosis and Support" />
      </a>
    </span>

    <span class="nav-menu-middle" :class="{ open: menuIsOpen }">
      <a
        v-for="(link, index) in links"
        :key="index"
        v-on:click="menuIsOpen = false"
        ><RouterLink :to="link.url">{{ link.text }}</RouterLink></a
      >
    </span>

    <div class="nav-menu-right">
      <hamburger-icon @click="toggleMenu" :aria-expanded="menuIsOpen"></hamburger-icon>
    </div>
    <div class="contact-us">
      <a v-on:click="onLinkClick(contactUsButton.link)">
        <button>
          {{ contactUsButton.text }}
        </button>
      </a>
    </div>
  </nav>
</template>

<script>
import Hamburger from "./Hamburger.vue";
import shared from "../shared";

export default {
  props: {
    links: Array,
    contactUsButton: Object,
    condensed: Boolean,
  },
  data() {
    return {
      menuIsOpen: false,
    };
  },
  components: {
    "hamburger-icon": Hamburger,
  },
  methods: {
    toggleMenu() {
      this.menuIsOpen = !this.menuIsOpen;
    },
    onLinkClick(link) {
      shared.onLinkClick(link);
    },
  },
};
</script>

<style lang="scss">
@import "./../../variables.scss";

.contact-us > a > button {
  background-color: #000000;
  color: white;
  font-size: $medium;
  border-radius: $radius-sm;
  border: 1px solid $third;
}

.nav-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: $space-4 0;
  width: 100%;
  position: relative;

  // LOGO
  .nav-menu-left {
    display: flex;
    align-items: center;

    #logo img {
      display: block;
      height: 64px;
      width: auto;
      transition: height 0.2s ease;
    }
  }

  // NAV LINKS
  .nav-menu-middle {
    display: flex;
    justify-content: left;
    gap: $space-8;
    flex: 1;
    margin-left: $space-12;

    a {
      color: $third;
      text-decoration: none;
      font-size: $mobileLarge;
      transition: opacity 0.15s ease;

      &:hover {
        opacity: 0.75;
        cursor: pointer;
      }

      &.router-link-active {
        text-decoration: underline;
        text-underline-offset: 6px;
        text-decoration-thickness: 2px;
      }
    }
  }

  // HAMBURGER ICON
  .nav-menu-right {
    display: none;
  }

  transition: padding 0.2s ease;

  &.condensed {
    padding: $space-2 0;

    .nav-menu-left #logo img {
      height: 48px;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .nav-menu,
  .nav-menu .nav-menu-left #logo img {
    transition: none;
  }
}

// RESPONSIVE STYLES
@media (max-width: 1000px) {
  .nav-menu {
    flex-wrap: wrap;

    .nav-menu-left {
      flex: 1 1 100%;
      justify-content: space-between;
    }

    .nav-menu-middle {
      display: none;
      flex-direction: column;
      width: 100%;
      text-align: center;
      margin-top: $space-4;
      gap: 0;
      margin-left: 0px;

      > a {
        display: block;
        padding: $space-3 0;
        border-top: 1px solid rgba(255, 255, 255, 0.4);
      }
    }

    .nav-menu-middle.open {
      display: flex;
    }

    .nav-menu-right {
      display: block;
      position: absolute;
      top: $space-4 + 10px;
      right: 0;
      transition: top 0.2s ease;
    }

    &.condensed .nav-menu-right {
      top: $space-2 + 2px;
    }

    .contact-us {
      display: none;
    }
  }
}
</style>
